// Copied from CandidateAiDataTab.jsx (RekruterAI) -- same Interaction.CollectedAnswers shape,
// same parsing logic. Leads don't use the @questionsComplete/@documentsComplete markers (those
// are recruitment-flow specific), so displayQA/displayDocs will usually stay empty for a lead --
// kept anyway for consistency with the source pattern and in case SalesManager AI adopts them later.
export const extractInteractionData = (collectedAnswers) => {
    try {
        const answers = typeof collectedAnswers === "string"
            ? JSON.parse(collectedAnswers || "[]")
            : (collectedAnswers ?? []);
        const sorted = [...answers].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

        const displayAnswers = sorted
            .filter(a => a.display_name && a.value !== "__FORM_ACTION_RESUMED__" && a.value !== "uploaded");

        const qCompleteIdx = sorted.findIndex(a => a.name === "@questionsComplete");
        const dCompleteIdx = sorted.findIndex(a => a.name === "@documentsComplete");
        const qEnd = qCompleteIdx !== -1 ? qCompleteIdx : sorted.length;

        const displayQA = sorted
            .slice(0, qEnd)
            .filter(a => !a.display_name && !a.name.startsWith("@"));

        const displayDocs = qCompleteIdx !== -1 && dCompleteIdx !== -1
            ? sorted.slice(qCompleteIdx + 1, dCompleteIdx).filter(a => !a.display_name && !a.name.startsWith("@"))
            : [];

        return { displayAnswers, displayQA, displayDocs };
    } catch {
        return { displayAnswers: [], displayQA: [], displayDocs: [] };
    }
};
